import React from "react";

const ProgessBar = () => (
  <div className="w-full rounded-full overflow-hidden bg-secondary">
    <div className="animate-progress-bar w-1/4 block h-full bg-pro-web-hill rounded-full"></div>
  </div>
);

export default ProgessBar;